import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { lazy, Suspense, useEffect } from "react";
import { Redirect, Route, Switch } from "react-router";
import ErrorBoundary from "./components/ErrorBoundary";
import { useAppDispatch } from "./utils/hooks";
import { loadSettings } from "./redux/slices/settingsSlice";
import Footer from "./components/Footer";
import Header from "./components/Header";
import fetchIntercept from "fetch-intercept";
import { localeData } from "./data/locale";
import { localeTo } from "./utils/helpers";
// pages
const Home = lazy(() => import("./pages/Home"));
const Jobs = lazy(() => import("./pages/Jobs"));
const UnderConstruction = lazy(() => import("./pages/UnderDev"));

function Main() {
  const dispatch = useAppDispatch();

  // mount logic
  useEffect(() => {
    // add Website-Key header to all fetch requests
    const unregister = fetchIntercept.register({
      request(url, config = {}) {
        config.headers = { ...config.headers, "Website-Key": "satc_public" };
        return [url, config];
      },
    });
    dispatch(loadSettings());
    return () => unregister();
  }, []); // eslint-disable-line

  return (
    <>
      <Header />
      <Suspense
        fallback={
          <div className="text-center page-placeholder">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: "28px" }} />}
            />
          </div>
        }
      >
        <Switch>
          <Route path="/" exact={true}>
            <ErrorBoundary>
              <Home />
            </ErrorBoundary>
          </Route>
          <Route path="/jobs">
            <ErrorBoundary>
              <Jobs />
            </ErrorBoundary>
          </Route>
          <Route path="/204">
            <ErrorBoundary>
              <UnderConstruction />
            </ErrorBoundary>
          </Route>
          <Route path="/404">
            <div className="page">
              <div className="container">
                <h1 className="text-center">404 - {localeData.noContent}</h1>
              </div>
            </div>
          </Route>
          {/* redirects  */}
          <Redirect from="/transport" to="/204" />
          <Redirect to={localeTo("/404")} />
        </Switch>
      </Suspense>
      <Footer />
    </>
  );
}

export default Main;
